import request from "@/utils/request";

import { IUser, IUserPatchResponse } from "@/interfaces/responses/user";
import { IUpdateUserInfo } from "@/interfaces/_shared/user";

/**
 * Get the logged in user
 */
export async function getUser(): Promise<IUser> {
  const response = await request({
    method: "get",
    url: "/user",
  });

  return response.data;
}

/**
 * Update user info
 * Postman: `PATCH_user`
 */
export async function patchUser(
  userData: IUpdateUserInfo
): Promise<IUserPatchResponse> {
  const response = await request({
    url: `/user`,
    method: "patch",
    data: userData,
  });

  return response.data;
}
